import { useEffect, useMemo, useRef, useState } from "react";
import {
  PRESENCE_DISAPPEAR_DEBOUNCE_MS,
  PRESENCE_STALE_RETAIN_MS,
  stabilizePresenceRows,
} from "../utils/platformPresenceStabilization";

const TICK_MS = 2_000;

/**
 * Suaviza entradas/saídas de presença: debounce curto, card “saindo” e ordenação estável.
 * @param {object[]} rawRows
 */
export function useStabilizedPresenceRows(rawRows) {
  const cacheRef = useRef(new Map());
  const orderCounterRef = useRef(0);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((x) => x + 1), TICK_MS);
    return () => clearInterval(id);
  }, []);

  const rows = useMemo(() => {
    return stabilizePresenceRows(rawRows, cacheRef.current, {
      now: Date.now(),
      orderCounterRef,
    });
    // tick força reavaliação de expiração de cards “saindo”
  }, [rawRows, tick]);

  const stats = useMemo(() => {
    let active = 0;
    let stale = 0;
    for (const row of rows) {
      if (row.presenceStale) stale += 1;
      else active += 1;
    }
    return { active, stale, total: rows.length };
  }, [rows]);

  return { rows, stats };
}

export { PRESENCE_DISAPPEAR_DEBOUNCE_MS, PRESENCE_STALE_RETAIN_MS };
